import { HttpClient } from "../../services/api/httpclient.service";
import { AxiosError } from "axios";

export class LoginService extends HttpClient {
  constructor() {
    super();
  }

  public async login(email: string, password: string) {
    try {

      const response = await this.post("/auth/login", { email, password }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        success: true,
        user: response.user,
      };
    } catch (error: any) {
      console.error("Login service error:", error);

      const axiosError = error as AxiosError;
      const status = axiosError.response?.status || error.status;
      const backendMessage = axiosError.response?.data?.message || axiosError.response?.data?.detail || "Login failed";

      if (status === 422) {
        throw {
          success: false,
          message: "שם משתמש או סיסמה שגויים"
        };
      } 

      else if (status === 401) {
        throw {
          success: false,
          message: backendMessage.includes("Incorrect username or password")
            ? "שם משתמש או סיסמה שגויים"
            : backendMessage,
        };
      } else if (status === 503) {
        throw {
          success: false,
          message: "קיימת בעיית התחברות למערכת. נסה מאוחר יותר",
        };
      }

      throw {
        success: false,
        message: backendMessage,
      };
    }
  }

}

